<div
    class="sticky-wrapper"
    [@stickyAnimation]="hideStickyWrapper && (isMobile$ | async) === true ? 'hidden' : 'visible'">
    <ng-content></ng-content>
</div>
